export const PAYMENT_IN_WINDOW = 'PaymentInWindow'